import React from 'react'
import { Typography } from '@mui/material'

/**
 * @typedef {import('../../../definitions').SalePerson} SalePerson
 */

/**
 * @typedef {Object} SalePersonItemProps
 * @property {SalePerson} salePerson
 */

/**
 * Sale person information.
 * @param {SalePersonItemProps} props
 * @return {JSX.Element}
 */
export const SalePersonItem = ({ salePerson }) => {
  return (
    <div className="sale-person-item">
      {salePerson.subTerritory && (
        <Typography className="sale-person-item__sub-territory" variant={'h4'}>
          {salePerson.subTerritory}
        </Typography>
      )}
      {salePerson.spcompanyName && (
        <div className="sale-person-item__company">
          {salePerson.spcompanyName}
        </div>
      )}
      {(salePerson.spfirstName && salePerson.splastName) && (
        <div className="sale-person-item__name">
          {`${salePerson.spfirstName} ${salePerson.splastName}`}
        </div>
      )}
      {salePerson.spposition && (
        <div className="sale-person-item__position">
          {salePerson.spposition}
        </div>
      )}
      {salePerson.spphoneNumber && (
        <div className="sale-person-item__phone">
          {`T: ${salePerson.spphoneNumber}`}
        </div>
      )}
      {salePerson.spemailAddress && (
        <div className="sale-person-item__mail">
          {salePerson.spemailAddress}
        </div>
      )}
    </div>
  )
}
